import { Component } from '@angular/core';
//import { NgbModule } from '@ng-bootstrap/ng2-bootstrap';
import { Mastermgtservice } from './mastermgt.service'
import { Router } from '@angular/router';
import { Mastermgt } from './mastermgt';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LocalService } from '../../local.service';

declare var $: any;
@Component({
  selector: 'app-mastermgt',
  templateUrl: './mastermgt.component.html',
  styleUrls: ['./mastermgt.component.css'],
  providers: [Mastermgtservice]
})
export class MastermgtComponent  {
  public list;
  dashboardUrl: string;
  urlSafe: SafeResourceUrl;
  searchText: string;
  isExpanded = false;
  //public userid = localStorage.getItem('userid');
  public userid = this.localService.getJsonValue('userid');
  constructor(private _router: Router, private mastermgtservice: Mastermgtservice, 
    public sanitizer: DomSanitizer, private localService: LocalService) { }

  ngOnInit() {
    
    // this._getmappedmenudetails();
    this.dashboardUrl = '/team';
    
    this.mastermgtservice.getdata(this.userid).subscribe(
      (res) => {
        if (res != undefined) {
          this.list = res;
          this.dashboardUrl = this.list[0].mastercomponentname;
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.dashboardUrl);
          this._router.navigate(['/home/mastermgt/' + this.dashboardUrl], { state: { menuid: this.list[0].masterid, action: this.list[0].actionrights } });
        }
        //console.log(res);
        //console.log(this.list);
      },
      error => {
        //console.log(error);
      }
    );
 //   $('body').addClass('nav-sm').removeClass('nav-md');
  }
 
  changeLink(link: string) {
    this.dashboardUrl = link;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.dashboardUrl);
  }
  
  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
